import { requestApiV2 } from '@library'
import { T3CConfig, QueueInfo, T3CSkillGroup } from '@types'

export function getT3cSdkUrl (payload?: { refresh: boolean }) {
  return requestApiV2('/trpc.tcc.tcc_main.T3C/CreateLoginToken', payload)
}

export function addT3CConfig (payload: T3CConfig) {
  return requestApiV2('/trpc.tcc.tcc_main.T3C/CreateBizT3CApp', payload)
}

export function getT3CConfig () {
  return requestApiV2('/trpc.tcc.tcc_main.T3C/GetBizT3CApp')
}

export function editT3CConfig (payload: T3CConfig) {
  return requestApiV2('/trpc.tcc.tcc_main.T3C/UpdateBizT3CApp', payload)
}

export function getCallDuration (payload?: { startTime?: string; endTime?: string }) {
  return requestApiV2<{ callDuration: number; callTime: number }>('/trpc.tcc.tcc_main.Call/GetT3CSalesCallInfo', payload)
}

export function getIncomingQueueCount (payload?: { skillGroupIds?: number[] }) {
  return requestApiV2<QueueInfo>('/trpc.tcc.tcc_main.Call/GetSkillGroupQueueCount', payload)
}

export function getSalesT3CSkillGroup () {
  return requestApiV2<{skillGroups: T3CSkillGroup[]}>('trpc.tcc.tcc_main.Call/GetSalesT3CSkillGroup')
}

/**
 * 通过sessionId获取原始主叫号码
 * 用于400热线meeting来源场景，获取实际的来电号码
 */
export function getT3CCallInRecordCallerBySessionId (payload: { sessionId: string }) {
  return requestApiV2<{ caller: string }>('/trpc.tcc.tcc_main.Call/GetT3CCallInRecordCallerBySessionId', payload)
}
